import { stitch } from 'keo';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import DropDownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { Tabs, Tab } from 'material-ui/Tabs';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { getReportDefaultFilter } from 'utils/helpers';

import { beMe } from 'redux/auth/actions';
import { editInUi } from 'redux/ui/actions';

import {
    accent1Color,
    appBarColor,
    userDropdownBackgroundColor,
    white,
} from 'constants/colors';
import { MePropType } from 'proptypes/records';

const propTypes = {
    beMe: PropTypes.func.isRequired,
    editShowUserMenu: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    me: MePropType,
    pathname: PropTypes.string.isRequired,
    showUserMenu: PropTypes.bool.isRequired,
};

const style = {
    buttonContainer: { display: 'flex' },
    label: {
        color: accent1Color,
        fontSize: 16,
        fontWeight: 400,
        paddingRight: 0,
        textTransform: 'capitalize',
    },
    list: { backgroundColor: userDropdownBackgroundColor },
    menuItem: {
        backgroundColor: userDropdownBackgroundColor,
        color: white,
        fontSize: 15,
        lineHeight: '40px',
        minHeight: 20,
        width: 50,
    },
    tab: {
        color: accent1Color,
        fontSize: 15,
        fontWeight: 400,
        textTransform: 'capitalize',
        width: 100,
    },
    tabItemContainer: { backgroundColor: appBarColor },
    tabs: { marginLeft: 12 },
};

const render = ({ props }) => {
    const { editShowUserMenu, me, pathname, showUserMenu } = props;
    const isActive = [
        '/billing',
        '/settings',
        '/help',
    ].includes(`/${pathname.split('/')[1] || ''}`);
    const userMenuStyle = {
        transform: showUserMenu ? 'rotate(-180deg)' : null,
        transition: 'transform 333ms ease',
    };
    const isAdmin = me.get('isAdmin');
    const toggleUserMenu = () => editShowUserMenu(!showUserMenu);
    return (
        r.div({ style: style.buttonContainer }, [
            r(Tabs, {
                inkBarStyle: style.inkBar,
                style: style.tabs,
                tabItemContainerStyle: style.tabItemContainer,
                value: isActive,
            }, [
                r(Tab, {
                    buttonStyle: { height: 60 },
                    disableTouchRipple: true,
                    label: me.get('fullName') || 'Account',
                    onActive: toggleUserMenu,
                    style: style.tab,
                    value: true,
                }),
            ]),
            r(IconMenu, {
                animated: false,
                autoWidth: false,
                iconButtonElement: (
                    r(IconButton, {
                        disableTouchRipple: true,
                        iconStyle: userMenuStyle,
                        style: { height: 60 },
                    }, [
                        r(DropDownArrow, { color: accent1Color }),
                    ])
                ),
                listStyle: style.list,
                onRequestChange: toggleUserMenu,
                open: showUserMenu,
                targetOrigin: { horizontal: 'left', vertical: 'bottom' },
                width: 150,
            }, [
                r(MenuItem, {
                    containerElement: r(Link, { to: '/billing' }),
                    isRendered: !isAdmin,
                    primaryText: 'Billing',
                    style: style.menuItem,
                }),
                r(MenuItem, {
                    containerElement: r(Link, { to: '/settings' }),
                    primaryText: 'Settings',
                    style: style.menuItem,
                }),
                r(MenuItem, {
                    containerElement: r(Link, { to: `/reports/?${getReportDefaultFilter()}` }),
                    isRendered: isAdmin,
                    primaryText: 'Reports',
                    style: style.menuItem,
                }),
                r(MenuItem, {
                    containerElement: r(Link, { to: '/help' }),
                    primaryText: 'Help',
                    style: style.menuItem,
                }),
                r(MenuItem, {
                    containerElement: r(Link, { to: '/logout' }),
                    primaryText: 'Log out',
                    style: style.menuItem,
                }),
            ])
        ])
    );
};

export default withRouter(stitch(
    { propTypes, render },
    ({ me, ui }) => ({
        me: me.get('data'),
        showUserMenu: ui.getIn(['navigation', 'showUserMenu'], false),
    }),
    {
        beMe,
        editShowUserMenu: editInUi(['navigation', 'showUserMenu']),
    }
));



// WEBPACK FOOTER //
// ./src/components/public/Navigation/NavigationBar/UserDropdown/index.js